import { render, staticRenderFns } from "./gradPhoto.vue?vue&type=template&id=484e9eae&scoped=true"
import script from "./gradPhoto.vue?vue&type=script&lang=js"
export * from "./gradPhoto.vue?vue&type=script&lang=js"
import style0 from "./gradPhoto.vue?vue&type=style&index=0&id=484e9eae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e9eae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484e9eae')) {
      api.createRecord('484e9eae', component.options)
    } else {
      api.reload('484e9eae', component.options)
    }
    module.hot.accept("./gradPhoto.vue?vue&type=template&id=484e9eae&scoped=true", function () {
      api.rerender('484e9eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/gradPhoto.vue"
export default component.exports